import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Admin from '@/page/admin/index'
import User from '@/page/user/index'
import Index from '@/page/index/index'
import NewIndex from '@/page/newIndex/index.vue'
import CustomIndex from '@/page/customIndex/index.vue'
import Audio from '@/components/audio/audio.vue'
import Event from '@/page/event/index.vue'
import Video from '@/page/video/video.vue'
import Visitor from '@/page/visitor/index.vue'
import Demo from '@/page/demo/index.vue'
import PhoneIndex1 from '@/page/phone/index1.vue'
import PhoneIndex2 from '@/page/phone/index2.vue'
import newIndex from '@/page/robotDetail/index/index.vue'
import privateIndex from '@/page/robotDetail/index/privateIndex.vue'
import playback from '@/page/playback/index.vue'
import statistics from '@/page/customIndex/statistics/index.vue'
import oil from '@/page/oil/index.vue'
import oilDetail from '@/page/oil/detail.vue'
import record from '@/page/oil/record.vue'
import { login as loginApi, setLanguage } from '@/api/admin'
import { setToken, getToken, getItem, setItem } from '@/utils/auth'
Vue.use(Router)

export const PRIVATE = false;

const router = new Router({
	routes: [{
			path: '/',
			name: 'login',
			component: Login
		},
		{
			path: '/admin',
			name: 'admin',
			component: Admin
		},
		{
			path: '/visitor',
			name: 'visitor',
			component: Visitor
		},
		{
			path: '/user',
			name: 'user',
			component: User
		},
		{
			path: '/demo',
			name: 'demo',
			component: Demo
		},
		{
			path: '/video',
			name: 'video',
			component: Video
		},
		{
			path: '/newindex',
			name: 'newindex',
			component: NewIndex
		},
		{
			path: '/index',
			name: 'customindex',
			component: CustomIndex
		},
		{
			path: '/test',
			name: 'test',
			component: Audio
		},
		{
			path: '/event',
			name: 'event',
			component: Event
		},
		{
			path: '/phone1',
			name: 'phone1',
			component: PhoneIndex1
		},
		{
			path: '/phone2',
			name: 'phone2',
			component: PhoneIndex2
		},
		{
			path: '/detail',
			name: 'detail',
			component: PRIVATE ? privateIndex : newIndex

		},
		{
			path: '/statistics',
			name: 'statistics',
			component: statistics
		},
		{
			path: '/playback',
			name: 'playback',
			component: playback
		},
		{
			path: '/oil',
			name: 'oil',
			component: oil
		},
		{
			path: '/oilDetail',
			name: 'oilDetail',
			component: oilDetail
		},
		{
			path: '/record',
			name: 'record',
			component: record
		}
	]
})

// ========== 自动登录辅助函数 ==========

/**
 * 生成浏览器指纹 CRC
 *
 * 必须逐字复现 Login.vue 中 int16_to_hex 的补零结果：那里的循环条件把计数器 j 与
 * result.length 同时递增，每个字节实际只补到 3 位十六进制，4 字节共 12 位
 * （如 07008402e0a1）。后端已按 12 位 crc 登记在线会话，若这里改成标准的 4 位补零
 * 会得到 16 位（00700084002e00a1），同一台机器经 _tk 自动登录与经登录页登录就会
 * 产生两个不同的 crc，被单点登录校验判成顶号踢下线。
 */
function generateCrc() {
	var canvas = document.createElement('canvas')
	var ctx = canvas.getContext('2d')
	var txt = 'http://security.tencent.com/'
	ctx.textBaseline = 'top'
	ctx.font = "14px 'Arial'"
	ctx.fillStyle = '#f60'
	ctx.fillRect(125, 1, 62, 20)
	ctx.fillStyle = '#069'
	ctx.fillText(txt, 2, 15)
	ctx.fillStyle = 'rgba(102, 204, 0, 0.7)'
	ctx.fillText(txt, 4, 17)
	var b64 = canvas.toDataURL().replace('data:image/png;base64,', '')
	var bin = atob(b64)
	// 取 bin 倒数第16到第12字节转为hex，补零规则与 Login.vue int16_to_hex 完全一致
	var result = ''
	for (var i = bin.length - 16; i < bin.length - 12; i++) {
		var hex = bin.charCodeAt(i).toString(16)
		var j = 0
		while (j + hex.length < 4) {
			hex = '0' + hex
			j++
		}
		result += hex
	}
	return result
}

/**
 * 从 hash 中移除指定查询参数，返回清理后的完整 hash 路径
 */
function removeHashParams(hash, keysToRemove) {
	var pathPart = hash // 默认无参数
	var queryIndex = hash.indexOf('?')
	if (queryIndex !== -1) {
		var pathOnly = hash.substring(0, queryIndex)
		var searchStr = hash.substring(queryIndex + 1)
		var remaining = searchStr.split('&').filter(function (pair) {
			var key = pair.split('=')[0]
			return keysToRemove.indexOf(decodeURIComponent(key)) === -1
		})
		pathPart = remaining.length > 0 ? pathOnly + '?' + remaining.join('&') : pathOnly
	}
	return pathPart
}

/**
 * 从 URL search 部分（window.location.search）移除指定参数
 * 用于自动登录失败时清除 _tk 参数，防止循环重试
 */
function cleanSearchParams(keysToRemove) {
	var searchParams = new URLSearchParams(window.location.search)
	keysToRemove.forEach(function (key) {
		searchParams.delete(key)
	})
	var remaining = searchParams.toString()
	var newUrl = window.location.pathname + (remaining ? '?' + remaining : '') + window.location.hash
	window.history.replaceState({}, document.title, newUrl)
}

/**
 * 解码 _tk 参数
 * _tk 值为 JSON {"account":"xxx","password":"xxx","userType":"1"} 的Base64编码
 * @returns {Object|null} 解码后的 { account, password, userType } 或 null
 */
function decodeTk(encoded) {
	try {
		// Base64 解码，补齐可能的 padding，支持 URL-safe Base64
		var base64 = encoded.replace(/-/g, '+').replace(/_/g, '/')
		var pad = base64.length % 4
		if (pad) base64 += '='.repeat(4 - pad)
		var jsonStr = decodeURIComponent(escape(atob(base64)))
		var params = JSON.parse(jsonStr)
		if (params.account && params.password && params.userType) {
			return params
		}
	} catch (e) {
		console.error('[Router Guard] _tk 参数解码失败:', e)
	}
	return null
}

// 标记是否正在进行自动登录，防止重复触发
var isAutoLoginInProgress = false

/**
 * 全局前置守卫：检测 /detail 页面的 _tk 加密登录参数并自动登录
 * URL格式示例: #/detail?robotId=xxx&_tk=eyJhY2NvdW50IjoiY29nc3N0YWZmMSIsInBhc3N3b3JkIjoiMTIzNDU2IiwidXNlclR5cGUiOiIyIn0
 */
router.beforeEach(function (to, from, next) {
	// 仅拦截跳转 /detail 且携带 _tk 参数的情况
	if (to.path !== '/detail') {
		next()
		return
	}

	// 从 to.query 获取 _tk 参数（vue-router 会自动解析 hash 中的 query）
	var tkParam = to.query._tk

	// 无 _tk 参数则直接放行
	if (!tkParam) {
		next()
		return
	}

	// 如果已经登录（token 存在），说明是 router.replace 后的二次导航，直接放行
	if (getToken()) {
		next()
		return
	}

	// 防止重复触发
	if (isAutoLoginInProgress) {
		next(false) // 阻止当前导航，等待正在进行的自动登录完成
		return
	}

	// 解码 _tk 参数
	var loginParams = decodeTk(tkParam)
	if (!loginParams) {
		console.error('[Router Guard] _tk 参数解析失败，跳转到登录页')
		router.replace({ name: 'login' })
		return
	}

	isAutoLoginInProgress = true
	console.log('[Router Guard] 检测到 _tk 登录参数，开始自动登录:', { account: loginParams.account, userType: loginParams.userType })

	// 生成 CRC 指纹
	var crc = generateCrc()

	// 确定语言
	var langZh = 'zh_CN'
	if (getItem('language') === 'English') {
		langZh = 'en_US'
	} else if (getItem('language') === 'Traditional') {
		langZh = 'zh_HK'
	}

	// 调用登录接口
	loginApi({
		account: loginParams.account,
		password: loginParams.password,
		userType: loginParams.userType,
		crc: crc,
		lang: langZh
	}).then(function (res) {
		if (res && res.data) {
			console.log('[Router Guard] 自动登录成功')
			// 保存登录信息（与 performAutoLogin 逻辑一致）
			setItem('kakcrc', crc)
			setItem('loginSuccess', new Date().getTime())
			setToken(res.data.token)
			setItem('token1', res.data.token)
			setItem('userInfo', res.data.userInfo)
			setItem('tenantInfoId', res.data.tenantInfoId)
			if (res.data.tenantInfoId) {
				setItem('webRtcId', res.data.tenantInfoId + '_' + new Date().getTime())
			}

			// 构建清理后的目标路径：移除 _tk，保留其他参数
			var currentHash = window.location.hash // 例如 #/detail?robotId=xxx&_tk=yyy...
			var cleanHash = removeHashParams(currentHash, ['_tk'])

			// 如果有语言设置需求，先处理语言切换
			if (getItem('language') === 'English') {
				setLanguage('en_US').then(function (langRes) {
					setItem('language', 'English')
					isAutoLoginInProgress = false
					router.replace(cleanHash.substring(1)) // 去掉 # 前缀
				}).catch(function () {
					isAutoLoginInProgress = false
					router.replace(cleanHash.substring(1))
				})
			} else {
				isAutoLoginInProgress = false
				router.replace(cleanHash.substring(1))
			}
		} else {
			console.error('[Router Guard] 自动登录返回异常:', res)
			isAutoLoginInProgress = false
			// 登录失败：清除 _tk 参数后跳转到登录页面，防止循环重试
			cleanSearchParams(['_tk'])
			router.replace({ name: 'login' })
		}
	}).catch(function (error) {
		console.error('[Router Guard] 自动登录失败:', error)
		isAutoLoginInProgress = false
		// 登录失败：清除 _tk 参数后跳转到登录页面，防止循环重试
		cleanSearchParams(['_tk'])
		router.replace({ name: 'login' })
	})

	// 不调用 next()，由登录完成后的 router.replace 接管导航
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js